import { useGetIAmQuery } from '@entities/Authentication/rtk-query.ts';
import { useAuthToken } from './use-auth-token';

type Role = 'anon' | 'coach' | 'client';

export const useUser = () => {
  const { data, isLoading, refetch: refetchIAm } = useGetIAmQuery(undefined);
  const { token } = useAuthToken();

  const getUserRole = (): Role => {
    if (!data?.id) return 'anon';
    if (data.is_coach) return 'coach';
    return 'client';
  };

  return {
    refetchIAm,
    user: data,
    isAuth: !!token,
    isLoading,
    role: getUserRole(),
  };
};
